import { Component, Input } from '@angular/core';
import { DataService } from '@manager-app/service/data.service';
import { AppEventModel, HxEventService, HxFioPipe } from 'hx-services';
import { DatePipe, NgFor } from '@angular/common';
import { HcIconComponent } from '../hc-icon/hc-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Component of invoice event list
 *
 * @example  <app-invoice-events [id]="someId"></app-invoice-events>
 */
@Component({
    selector: 'app-invoice-events',
    templateUrl: './invoice-events.component.html',
    imports: [NgFor, HcIconComponent, DatePipe, TranslocoPipe, HxFioPipe]
})
export class InvoiceEventsComponent {
  events: AppEventModel[] = [];
  statusList = DataService.statusList;
  eventList = DataService.eventList;
  @Input()
  set id(val: number) {
    if (val) {
      this.loadEvents(val);
    }
  }

  constructor(
    private eventService: HxEventService,
  ) {
  }

  private loadEvents(id: number) {
    this.eventService.getInvoiceEventList(id).then(events => {
      this.events = events;
    }, err => console.error(err));
  }
}
